import { GLOBAL_CATALOG_ITEMS_PAGE_SIZE } from '../consts/catalogItemsConsts';
import {
    CatalogItemSchema,
    GlobalCatalogItemsResponse,
    GlobalCatalogSearchState,
} from '../types/CatalogItemSchema';

export const buildGlobalCatalogQueryKey = ({
    searchString,
    categoryId,
    propertyId,
}: {
    searchString?: string;
    categoryId?: string;
    propertyId?: string;
}) => `${searchString ?? ''}::${categoryId ?? ''}::${propertyId ?? ''}`;

export const getGlobalCatalogTotalCount = (
    payload: GlobalCatalogItemsResponse,
) => payload.totalCount;

export const createInitialGlobalCatalogSearchState =
    (): GlobalCatalogSearchState => ({
        isLoadingMore: false,
        page: 1,
        pageSize: GLOBAL_CATALOG_ITEMS_PAGE_SIZE,
        hasNextPage: false,
        totalCount: 0,
        endCursor: '',
        queryKey: '',
    });

export const ensureGlobalCatalogSearchState = (state: CatalogItemSchema) => {
    if (!state.globalCatalogSearch) {
        state.globalCatalogSearch = createInitialGlobalCatalogSearchState();
    }

    return state.globalCatalogSearch;
};
